/* eslint-disable func-names */
/* eslint-disable no-restricted-globals */
// eslint-disable-next-line @typescript-eslint/class-name-casing
interface getPhoneNumberResponse {
  token: string | null;
  success: boolean;
}

export const getPhoneNumber = async (): Promise<null | getPhoneNumberResponse> => {
  if (
    window.microapps &&
    typeof window.microapps.getPhoneNumber === "function"
  ) {
    const response = await window.microapps
      .getPhoneNumber()
      .then(response => {
        return { token: response.toString(), success: true };
      })
      .catch(error => {
        console.error("An error occurred: ", error);
        return { token: error, success: false };
      });
    return response;
  }
  return null;
};

export const getIdentity = async (): Promise<null | string> => {
  if (window.microapps && typeof window.microapps.getIdentity === "function") {
    const response = await window.microapps
      .getIdentity()
      .then(response => response.toString())
      .catch(error => {
        console.error("An error occurred: ", error);
        return null;
      });
    return response;
  }
  return null;
};

export const createOrder = async (order: any): Promise<null | string> => {
  if (window.microapps && typeof window.microapps.createOrder === "function") {
    await window.microapps.createOrder(order);
  }
  return null;
};

export const checkIfGPay = () => {
  try {
    const gpayPath = window.location.pathname.includes("/gpay-bike"); // gpay-bike
    return gpayPath;
    // return (
    //   window.location.ancestorOrigins["0"] &&
    //   window.location.ancestorOrigins["0"].includes(
    //     "https://microapps.google.com"
    //   )
    // );
  } catch (e) {
    return false;
  }
};

export const appGoBack = url => {
  window.location.href = url;
  // const back = window?.history?.back();
  // console.log("history", window.history.back);
  // if (back === undefined || window.history.length === 1) {
  //   console.log("no history to go back");
  //   window.location.href = url;
  // }
  // return back;
};

export const setInLocalStorage = (key: string, value: string) => {
  window.localStorage.setItem(key, value);
};

export const getFromLocalStorage = (key: string) =>
  window.localStorage.getItem(key);

export default {};

export const gpayUpdateOrder = (payload: { order_id: string; order: any }) => {
  return window
    .ackoFetch(`/api/gpay/update_order/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" }
    })
    .then(res => res.json());
};

export const disableBrowserBack = () => {
  history.pushState(null, document.title, location.href);
  history.back();
  history.forward();
  window.onpopstate = function() {
    history.go(1);
  };
};
